import Button from 'app/shared/components/button/Button';
import Icon from 'app/shared/components/icon/Icon';
import IconLib from 'app/shared/components/icon/icon-lib';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import styledFuncs from 'app/styles/styledFuncs';
import React from 'react';
import styled from 'styled-components/macro';

const LinkButton = styled(Button)`
  width: 100%;
  margin: ${styledFuncs.pad(0.5)} 0;
  justify-content: start;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.161);
  border-radius: 10px;
`;
const LinkRightIcon = styled(Icon).attrs({
  icon: IconLib.CHEVRON_RIGHT,
})`
  position: absolute;
  right: ${styledFuncs.pad(2)};
`;
type LinkParams = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
};
export default function ProfileLinks({
  text,
  onClick,
  disabled,
}: LinkParams): JSX.Element {
  useSetPageTitle('Business Type');

  return (
    <>
      <LinkButton
        color="default"
        onClick={onClick}
        disabled={disabled}
      >
        {text}
        <LinkRightIcon size={30} />
      </LinkButton>
    </>
  );
}
